module.exports = __webpack_public_path__ + "static/media/Forces.1151fc06.svg";